export class ObjectAnimatorBase {
    constructor(canvasElement, appClient) {
        this.canvas = canvasElement;
        this.appClient = appClient;
        this.activeElements = new Map(); // clipId -> HTMLElement
    }

    static injectStyles(styles, styleId) {
        if (styles && !document.getElementById(styleId)) {
            const styleElement = document.createElement('style');
            styleElement.id = styleId;
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }
    }

    update(activeClips, currentTime) {
        const activeClipIds = new Set(activeClips.map(c => c._id));

        // Render/update active clips
        for (const clip of activeClips) {
            this.render(clip, currentTime);
        }

        // Remove elements for clips that are no longer active
        for (const [clipId, element] of this.activeElements.entries()) {
            if (!activeClipIds.has(clipId)) {
                element.remove();
                this.activeElements.delete(clipId);
            }
        }
    }

    render(clip, currentTime) {
        throw new Error("Render method must be implemented by subclasses.");
    }

    destroy() {
        for (const element of this.activeElements.values()) {
            element.remove();
        }
        this.activeElements.clear();
    }
}
